const onLoad = () => {
  const main = document.querySelector('#main')
  const header = document.querySelector('[data-header]')

  main.style.paddingTop = `${header.offsetHeight}px`
}

export default onLoad
